import { useCallback, useRef, useState } from 'react';
import { useRefsByKey } from 'src/hooks';
import { calculateItemJoinerCoordinates } from 'src/utils/reordering/calculateItemJoinerCoordinates';

interface Parameters {
  orderedTagTypes: Array<{ id: string }>;
  draggingId: string | null;
}

export const useTagsTypesCoordinates = ({
  orderedTagTypes,
  draggingId,
}: Parameters) => {
  const tagTypesContainerRef = useRef<HTMLDivElement>(null);
  const { refsByKey, setRef } = useRefsByKey();
  const [tagTypeJoinerCoordinates, setTagTypeJoinerCoordinates] = useState<
    (number[] | null[])[]
  >([]);

  const recalculateCoordinates = useCallback(() => {
    if (orderedTagTypes.length) {
      setTagTypeJoinerCoordinates(
        orderedTagTypes.map((tagType, index) =>
          calculateItemJoinerCoordinates({
            item: tagType,
            index,
            draggingId,
            orderedList: orderedTagTypes,
            listContainerRef: tagTypesContainerRef,
            refsByKey,
          }),
        ),
      );
    }
  }, [draggingId, orderedTagTypes, tagTypesContainerRef, refsByKey]);

  return {
    tagTypesContainerRef,
    setRef,
    tagTypeJoinerCoordinates,
    recalculateCoordinates,
  };
};
